export const UPDATE_MODAL_STATE = "UPDATE_MODAL_STATE";
export const REQUEST_OPEN_MODAL = "REQUEST_OPEN_MODAL";
